'use client'

import { createContext, useContext } from 'react'

import type { FlagValues } from '../core/types'

const FlagContext = createContext<FlagValues>({})

interface FlagProviderProps {
  children: React.ReactNode
  values: FlagValues
}

export const FlagProvider = ({ children, values }: FlagProviderProps) => {
  return <FlagContext.Provider value={values}>{children}</FlagContext.Provider>
}

export const useFlagContext = (): FlagValues => {
  return useContext(FlagContext)
}
